import React from 'react'
import loadingGif from '../img/loading.gif'
import { Box } from '@mui/material';

export default function LoadingBox({ display, children, sx }) {
  if (display) {
    return (
      <Box sx={sx}>
        <img src={loadingGif} width="40px" alt="Loading..."/>
      </Box>
    );
  }
  return <Box sx={sx}>{children}</Box>;
}